// Utility functions for image URL handling

// PRODUCTION: ALWAYS use api.eezybooking.com - NEVER localhost
// DEVELOPMENT: Only use api.eezybooking.com when explicitly in development mode
const API_BASE_URL = process.env.NODE_ENV === 'production'
  ? 'https://api.eezybooking.com' // FORCE production URL in production builds
  : 'https://api.eezybooking.com'; // Only for development

// Normalize any image path to ensure it starts from /uploads/...
export const normalizeImagePath = (url) => {
  if (!url) return url;
  
  // In development: Replace api.eezybooking.com with api.eezybooking.com
  if (process.env.NODE_ENV !== 'production') {
    url = url.replace(/https:\/\/api\.eezybooking\.com/g, 'https://api.eezybooking.com');
    url = url.replace(/http:\/\/api\.eezybooking\.com/g, 'https://api.eezybooking.com');
  }
  
  // In production: Replace api.eezybooking.com with production API
  if (process.env.NODE_ENV === 'production' && !API_BASE_URL.includes('localhost')) {
    const productionBase = API_BASE_URL.replace(/\/api$/, '') || 'https://api.eezybooking.com';
    url = url.replace(/http:\/\/api.eezybooking.com/g, productionBase);
    url = url.replace(/http:\/\/127\.0\.0\.1:8001/g, productionBase);
    url = url.replace(/https:\/\/api.eezybooking.com/g, productionBase);
    url = url.replace(/https:\/\/127\.0\.0\.1:8001/g, productionBase);
  }
  
  // If already a full URL, return as is (after replacement)
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  
  // Extract path from /uploads/...
  const uploadsIndex = url.indexOf('/uploads/');
  if (uploadsIndex !== -1) {
    return url.substring(uploadsIndex);
  }
  return url;
};

// Helper function to get full image URL
export const getImageUrl = (imageUrl) => {
  if (!imageUrl) return null;
  
  // Normalize the path first (handles URL replacement)
  let normalized = normalizeImagePath(imageUrl);
  if (!normalized) return null;
  
  // If already a full URL, return as is (after normalization)
  if (normalized.startsWith('http://') || normalized.startsWith('https://')) {
    // In development: Ensure no api.eezybooking.com URLs
    if (process.env.NODE_ENV !== 'production') {
      normalized = normalized.replace(/https:\/\/api\.eezybooking\.com/g, 'https://api.eezybooking.com');
      normalized = normalized.replace(/http:\/\/api\.eezybooking\.com/g, 'https://api.eezybooking.com');
    }
    // In production: Ensure no localhost URLs
    if (process.env.NODE_ENV === 'production' && !API_BASE_URL.includes('localhost')) {
      const productionBase = API_BASE_URL.replace(/\/api$/, '') || 'https://api.eezybooking.com';
      normalized = normalized.replace(/http:\/\/api.eezybooking.com/g, productionBase);
      normalized = normalized.replace(/http:\/\/127\.0\.0\.1:8001/g, productionBase);
      normalized = normalized.replace(/https:\/\/api.eezybooking.com/g, productionBase);
      normalized = normalized.replace(/https:\/\/127\.0\.0\.1:8001/g, productionBase);
    }
    return normalized;
  }
  
  // Use the configured base URL (without /api suffix for images)
  // In production, FORCE api.eezybooking.com
  let baseUrl = API_BASE_URL.replace(/\/api$/, '');
  if (process.env.NODE_ENV === 'production') {
    baseUrl = 'https://api.eezybooking.com';
  } else if (!baseUrl) {
    baseUrl = 'https://api.eezybooking.com';
  }
  // Safety check: Replace any localhost references in production
  if (process.env.NODE_ENV === 'production') {
    baseUrl = baseUrl.replace(/http:\/\/api.eezybooking.com/g, 'https://api.eezybooking.com');
    baseUrl = baseUrl.replace(/https:\/\/api.eezybooking.com/g, 'https://api.eezybooking.com');
    baseUrl = baseUrl.replace(/api.eezybooking.com/g, 'api.eezybooking.com');
  }
  
  // Ensure path starts with /
  const imagePath = normalized.startsWith('/') ? normalized : `/${normalized}`;
  
  return `${baseUrl}${imagePath}`;
};
